import React from 'react';
import { CardBody, Col, FormGroup, Row } from 'reactstrap';
import {
    NdaTerms,
    NdaTermsList,
} from '../../../../../../slices/marketplace/buyer/models/buyer-nda-term-preferences';
import { Input } from '@availity/form';
import './NdaTermPreferences.scss';
import InfoTooltip from '../../../../../../components/info-tooltip/info-tooltip';
import {
    namesBlindedTermTooltipText,
    namesVisibleTermTooltipText,
    nonDisclosurePeriodTooltipText,
    nonSoliciationPeriodTooltipText,
} from '../../../../../../utils/constants';

interface NdaTermPreferencesProps {
    isSaving: boolean;
    isReadonly: boolean;
    isFullScreen: boolean;
}

export const NdaTermPreferences = (props: NdaTermPreferencesProps) => {
    return (
        <div className="nda-terms-preferences">
            <CardBody className="description-form">
                <div className="nda-terms">
                    <table className="table">
                        <thead>
                            <tr>
                                <th
                                    rowSpan={2}
                                    className="non-disclosure-period-column">
                                    <div className="nda-title">
                                        <label>
                                            {'Non-Disclosure Period'}
                                            <InfoTooltip
                                                text={
                                                    nonDisclosurePeriodTooltipText
                                                }
                                                idText="non-disclosure-period-tooltip"
                                            />
                                        </label>
                                    </div>
                                </th>
                                <th colSpan={4}>
                                    <div className="nda-title">
                                        <label>
                                            {'Non-Solicitation Period '}
                                            <InfoTooltip
                                                text={
                                                    nonSoliciationPeriodTooltipText
                                                }
                                                idText="non-solicitation-period-tooltip"
                                            />
                                        </label>
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                <th colSpan={2} className="text-center">
                                    <label>DVMs / Management</label>
                                </th>
                                <th colSpan={2} className="text-center">
                                    <label>Staff</label>
                                </th>
                            </tr>
                            <tr>
                                <th className=""></th>
                                <th className="name-visibile">
                                    <label>
                                        {'Names Visible'}
                                        <InfoTooltip
                                            text={namesVisibleTermTooltipText}
                                            idText="dvms-names-visible-tooltip"
                                        />
                                    </label>
                                </th>
                                <th className="name-blinded">
                                    <label>
                                        {'Names Blinded'}
                                        <InfoTooltip
                                            text={namesBlindedTermTooltipText}
                                            idText="dvms-names-blinded-tooltip"
                                        />
                                    </label>
                                </th>
                                <th className="name-visibile">
                                    <label>
                                        {'Names Visible'}
                                        <InfoTooltip
                                            text={namesVisibleTermTooltipText}
                                            idText="staff-names-visible-tooltip"
                                        />
                                    </label>
                                </th>
                                <th className="name-blinded">
                                    <div>
                                        <label>
                                            {'Names Blinded'}
                                            <InfoTooltip
                                                text={
                                                    namesBlindedTermTooltipText
                                                }
                                                idText="staff-names-blinded-tooltip"
                                            />
                                        </label>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="nda-row">
                                <td>
                                    <FormGroup>
                                        <Input
                                            className={
                                                props.isReadonly
                                                    ? 'readonly-field select-no-arrow'
                                                    : ''
                                            }
                                            type="select"
                                            disabled={
                                                props.isSaving ||
                                                props.isReadonly
                                            }
                                            name={'nonDisclosurePeriod'}>
                                            {[...NdaTermsList]
                                                .filter(
                                                    (x) => x.id !== NdaTerms.NA
                                                )
                                                .map((item) => (
                                                    <option
                                                        value={item.id}
                                                        key={item.id}>
                                                        {item.name}
                                                    </option>
                                                ))}
                                        </Input>
                                    </FormGroup>
                                </td>
                                <td className="name-visibile">
                                    <FormGroup>
                                        <Input
                                            type="select"
                                            className={
                                                props.isReadonly
                                                    ? 'readonly-field select-no-arrow'
                                                    : ''
                                            }
                                            disabled={
                                                props.isSaving ||
                                                props.isReadonly
                                            }
                                            name={
                                                'nonSolicitationDvmNamesVisible'
                                            }>
                                            {[...NdaTermsList].map((item) => (
                                                <option
                                                    value={item.id}
                                                    key={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </td>
                                <td className="name-blinded">
                                    <FormGroup>
                                        <Input
                                            className={
                                                props.isReadonly
                                                    ? 'readonly-field select-no-arrow'
                                                    : ''
                                            }
                                            type="select"
                                            disabled={
                                                props.isSaving ||
                                                props.isReadonly
                                            }
                                            name={
                                                'nonSolicitationDvmNamesBlinded'
                                            }>
                                            {[...NdaTermsList].map((item) => (
                                                <option
                                                    value={item.id}
                                                    key={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </td>
                                <td className="name-visibile">
                                    <FormGroup>
                                        <Input
                                            className={
                                                props.isReadonly
                                                    ? 'readonly-field select-no-arrow'
                                                    : ''
                                            }
                                            type="select"
                                            disabled={
                                                props.isSaving ||
                                                props.isReadonly
                                            }
                                            name={
                                                'nonSolicitationStaffNamesVisible'
                                            }>
                                            {[...NdaTermsList].map((item) => (
                                                <option
                                                    value={item.id}
                                                    key={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </td>
                                <td className="name-blinded">
                                    <FormGroup>
                                        <Input
                                            className={
                                                props.isReadonly
                                                    ? 'readonly-field select-no-arrow'
                                                    : ''
                                            }
                                            type="select"
                                            disabled={
                                                props.isSaving ||
                                                props.isReadonly
                                            }
                                            name={
                                                'nonSolicitationStaffNamesBlinded'
                                            }>
                                            {[...NdaTermsList].map((item) => (
                                                <option
                                                    value={item.id}
                                                    key={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </CardBody>
        </div>
    );
};
